import React from 'react';
import { Card } from '../components/ui/Card';
import { SearchIcon, PlusIcon, FilterIcon, DownloadIcon, ClipboardListIcon, CalendarIcon, BarChartIcon } from 'lucide-react';
export const Examinations = () => {
  return <div className="space-y-6" data-id="element-589">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between" data-id="element-590">
        <div data-id="element-591">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-592">
            Examination Management
          </h1>
          <p className="mt-1 text-sm text-gray-500" data-id="element-593">
            Manage exams, schedules, and results
          </p>
        </div>
        <div className="mt-4 sm:mt-0" data-id="element-594">
          <button className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 flex items-center" data-id="element-595">
            <PlusIcon size={18} className="mr-1" data-id="element-596" />
            <span data-id="element-597">Schedule Exam</span>
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-598">
        <Card className="bg-gradient-to-r from-blue-50 to-blue-100 border border-blue-200" data-id="element-599">
          <div className="flex items-center" data-id="element-600">
            <div className="p-3 rounded-full bg-blue-500 bg-opacity-10" data-id="element-601">
              <CalendarIcon size={24} className="text-blue-600" data-id="element-602" />
            </div>
            <div className="ml-4" data-id="element-603">
              <p className="text-sm font-medium text-blue-600" data-id="element-604">
                Upcoming Exams
              </p>
              <p className="text-2xl font-bold text-blue-700" data-id="element-605">12</p>
            </div>
          </div>
        </Card>
        <Card className="bg-gradient-to-r from-green-50 to-green-100 border border-green-200" data-id="element-606">
          <div className="flex items-center" data-id="element-607">
            <div className="p-3 rounded-full bg-green-500 bg-opacity-10" data-id="element-608">
              <ClipboardListIcon size={24} className="text-green-600" data-id="element-609" />
            </div>
            <div className="ml-4" data-id="element-610">
              <p className="text-sm font-medium text-green-600" data-id="element-611">
                Results Published
              </p>
              <p className="text-2xl font-bold text-green-700" data-id="element-612">28</p>
            </div>
          </div>
        </Card>
        <Card className="bg-gradient-to-r from-purple-50 to-purple-100 border border-purple-200" data-id="element-613">
          <div className="flex items-center" data-id="element-614">
            <div className="p-3 rounded-full bg-purple-500 bg-opacity-10" data-id="element-615">
              <BarChartIcon size={24} className="text-purple-600" data-id="element-616" />
            </div>
            <div className="ml-4" data-id="element-617">
              <p className="text-sm font-medium text-purple-600" data-id="element-618">
                Average Pass Rate
              </p>
              <p className="text-2xl font-bold text-purple-700" data-id="element-619">76%</p>
            </div>
          </div>
        </Card>
      </div>
      <Card title="Upcoming Examinations" data-id="element-620">
        <div className="overflow-x-auto" data-id="element-621">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-622">
            <thead className="bg-gray-50" data-id="element-623">
              <tr data-id="element-624">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-625">
                  Exam Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-626">
                  Course
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-627">
                  Date
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-628">
                  Time
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-629">
                  Venue
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-630">
                  Students
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-631">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-632">
              {[{
              name: 'Mid-Term Examination',
              course: 'B.Tech CSE - Sem 3',
              date: 'Sep 15, 2023',
              time: '10:00 AM - 12:00 PM',
              venue: 'Exam Hall A',
              students: 120
            }, {
              name: 'End-Term Examination',
              course: 'BBA - Sem 1',
              date: 'Sep 18, 2023',
              time: '2:00 PM - 4:00 PM',
              venue: 'Exam Hall B',
              students: 85
            }, {
              name: 'Mid-Term Examination',
              course: 'B.Sc Physics - Sem 5',
              date: 'Sep 20, 2023',
              time: '10:00 AM - 12:00 PM',
              venue: 'Exam Hall C',
              students: 65
            }, {
              name: 'Practical Examination',
              course: 'B.Tech ECE - Sem 3',
              date: 'Sep 22, 2023',
              time: '9:00 AM - 1:00 PM',
              venue: 'Lab Complex',
              students: 75
            }, {
              name: 'End-Term Examination',
              course: 'B.Com - Sem 3',
              date: 'Sep 25, 2023',
              time: '2:00 PM - 4:00 PM',
              venue: 'Exam Hall A',
              students: 95
            }].map((exam, index) => <tr key={index} data-id="element-633">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-634">
                    <div className="text-sm font-medium text-gray-900" data-id="element-635">
                      {exam.name}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-636">
                    {exam.course}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-637">
                    {exam.date}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-638">
                    {exam.time}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-639">
                    {exam.venue}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-640">
                    {exam.students}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-641">
                    <a href="#" className="text-indigo-600 hover:text-indigo-900 mr-3" data-id="element-642">
                      View
                    </a>
                    <a href="#" className="text-indigo-600 hover:text-indigo-900" data-id="element-643">
                      Edit
                    </a>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
      <Card title="Recent Results" data-id="element-644">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between pb-4 border-b border-gray-200" data-id="element-645">
          <div className="relative" data-id="element-646">
            <span className="absolute inset-y-0 left-0 flex items-center pl-3" data-id="element-647">
              <SearchIcon size={18} className="text-gray-400" data-id="element-648" />
            </span>
            <input type="text" placeholder="Search by course or exam..." className="pl-10 pr-4 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 w-full sm:w-64" data-id="element-649" />
          </div>
          <div className="mt-3 sm:mt-0 flex space-x-2" data-id="element-650">
            <button className="px-3 py-2 border border-gray-300 rounded-md text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 flex items-center" data-id="element-651">
              <FilterIcon size={16} className="mr-1" data-id="element-652" />
              <span data-id="element-653">Filters</span>
            </button>
            <button className="px-3 py-2 border border-gray-300 rounded-md text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 flex items-center" data-id="element-654">
              <DownloadIcon size={16} className="mr-1" data-id="element-655" />
              <span data-id="element-656">Export</span>
            </button>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-657">
          <table className="min-w-full divide-y divide-gray-200 mt-4" data-id="element-658">
            <thead className="bg-gray-50" data-id="element-659">
              <tr data-id="element-660">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-661">
                  Exam
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-662">
                  Course
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-663">
                  Date Conducted
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-664">
                  Results Date
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-665">
                  Pass %
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-666">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-667">
              {[{
              name: 'End-Term Examination',
              course: 'B.Tech CSE - Sem 2',
              conductedDate: 'May 20, 2023',
              resultsDate: 'Jun 10, 2023',
              passPercentage: 82
            }, {
              name: 'Mid-Term Examination',
              course: 'BBA - Sem 2',
              conductedDate: 'Apr 15, 2023',
              resultsDate: 'Apr 30, 2023',
              passPercentage: 78
            }, {
              name: 'End-Term Examination',
              course: 'B.Sc Physics - Sem 4',
              conductedDate: 'May 18, 2023',
              resultsDate: 'Jun 8, 2023',
              passPercentage: 68
            }, {
              name: 'Practical Examination',
              course: 'B.Tech ECE - Sem 2',
              conductedDate: 'May 12, 2023',
              resultsDate: 'May 25, 2023',
              passPercentage: 92
            }, {
              name: 'End-Term Examination',
              course: 'B.Com - Sem 2',
              conductedDate: 'May 22, 2023',
              resultsDate: 'Jun 12, 2023',
              passPercentage: 74
            }].map((result, index) => <tr key={index} data-id="element-668">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-669">
                    <div className="text-sm font-medium text-gray-900" data-id="element-670">
                      {result.name}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-671">
                    {result.course}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-672">
                    {result.conductedDate}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-673">
                    {result.resultsDate}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-674">
                    <div className="flex items-center" data-id="element-675">
                      <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${result.passPercentage >= 80 ? 'bg-green-100 text-green-800' : result.passPercentage >= 70 ? 'bg-yellow-100 text-yellow-800' : 'bg-red-100 text-red-800'}`} data-id="element-676">
                        {result.passPercentage}%
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-677">
                    <a href="#" className="text-indigo-600 hover:text-indigo-900 mr-3" data-id="element-678">
                      View
                    </a>
                    <a href="#" className="text-indigo-600 hover:text-indigo-900" data-id="element-679">
                      Download
                    </a>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="flex items-center justify-between border-t border-gray-200 px-4 py-3 sm:px-6 mt-4" data-id="element-680">
          <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between" data-id="element-681">
            <div data-id="element-682">
              <p className="text-sm text-gray-700" data-id="element-683">
                Showing <span className="font-medium" data-id="element-684">1</span> to{' '}
                <span className="font-medium" data-id="element-685">5</span> of{' '}
                <span className="font-medium" data-id="element-686">28</span> results
              </p>
            </div>
            <div data-id="element-687">
              <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination" data-id="element-688">
                <a href="#" className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-689">
                  <span className="sr-only" data-id="element-690">Previous</span>
                  <span data-id="element-691">«</span>
                </a>
                <a href="#" aria-current="page" className="z-10 bg-indigo-50 border-indigo-500 text-indigo-600 relative inline-flex items-center px-4 py-2 border text-sm font-medium" data-id="element-692">
                  1
                </a>
                <a href="#" className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium" data-id="element-693">
                  2
                </a>
                <a href="#" className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium" data-id="element-694">
                  3
                </a>
                <span className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700" data-id="element-695">
                  ...
                </span>
                <a href="#" className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium" data-id="element-696">
                  6
                </a>
                <a href="#" className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-697">
                  <span className="sr-only" data-id="element-698">Next</span>
                  <span data-id="element-699">»</span>
                </a>
              </nav>
            </div>
          </div>
        </div>
      </Card>
    </div>;
};